import {UmpireArticle} from '../umpire-article';
import {
  ItemSelectionType,
  UmpireComponentHeroGeneric,
} from '../umpire-component-hero-generic';
import {UmpireComponentTypeEnum} from '../umpire-component-type-enum';

export interface UmpireComponentEvents
  extends UmpireComponentHeroGeneric<UmpireComponentTypeEnum.EVENTS> {
  button_text: string;
  description: string;
  external_url: string;
  has_button: boolean;
  events: UmpireArticle[];
  event_article_selections: Extract<
    ItemSelectionType,
    ItemSelectionType.auto | ItemSelectionType.manual
  >;
  event_articles_order: EventArticleOrder[];
}

export interface EventArticleOrder {
  article_id: string;
  article_index: number;
}
